module.exports = __webpack_public_path__ + "img/builder-2.89040aaa.webp";